import envService from '@/services/env.service';
import { datadogRum } from '@datadog/browser-rum';

function init() {
  datadogRum.init({
    applicationId: '812802a7-12b1-4f9f-974e-66715cc568be',
    clientToken: 'pubac39e99ef360561cb868bf79b243a4ed',
    site: 'us5.datadoghq.com',
    service: 'member-ui',
    env: (envService.getEnv().VITE_DEPLOYMENT_TARGET || 'local').toLowerCase(),
    version: envService.getEnv().VITE_VERSION || 'unknown',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [/https:\/\/.*\.catchbio\.com/],
    proxy: (options) => `${envService.getEnv().VITE_DATADOG_PROXY_URL}${options.path}?${options.parameters}`,
  });
}

export default { init };
